import React, { useEffect, useState } from "react";
import OrderModal from "../OrderModal/OrderModal";
import "../OrderModal/OrderModal.css";
import useApi from "../../hook/UseApi";
import { PopUp } from "../PopUp/PopUp";
import { OPEN_ORDER_EVENT, openOrderModal } from "../../utils/contactEvents";
import "./ContactFab.css";

const ContactFab: React.FC = () => {
	const api = useApi();
	const [panelOpen, setPanelOpen] = useState(false);
	const [orderOpen, setOrderOpen] = useState(false);
	const [popUp, setPopUp] = useState(false);

	useEffect(() => {
		const handler = () => {
			setOrderOpen(true);
			setPanelOpen(false);
		};
		window.addEventListener(OPEN_ORDER_EVENT, handler);
		return () => window.removeEventListener(OPEN_ORDER_EVENT, handler);
	}, []);

	useEffect(() => {
		if (api.error || api.data) {
			setPopUp(true);
		}
	}, [api.error, api.data]);

	return (
		<>
			<div className={`contact-fab ${panelOpen ? "is-open" : ""}`}>
				{panelOpen && (
					<div className="contact-fab-panel" role="dialog" aria-label="Связаться с нами">
						<p className="contact-fab-panel-title">Напишите нам</p>
						<button
							type="button"
							className="contact-fab-action contact-fab-action-order"
							onClick={() => {
								setPanelOpen(false);
								openOrderModal();
							}}
						>
							<i className="fa-solid fa-pen-to-square" aria-hidden />
							Оставить заявку
						</button>
						<a
							href="tel:+79647772525"
							className="contact-fab-action contact-fab-action-phone"
							onClick={() => setPanelOpen(false)}
						>
							<i className="fa-solid fa-phone" aria-hidden />
							+7 (964) 777-25-25
						</a>
					</div>
				)}

				<button
					type="button"
					className="contact-fab-toggle"
					aria-expanded={panelOpen}
					aria-label={panelOpen ? "Закрыть" : "Связаться"}
					onClick={() => setPanelOpen((v) => !v)}
				>
					<i className={`fa-solid ${panelOpen ? "fa-xmark" : "fa-comment-dots"}`} aria-hidden />
				</button>
			</div>

			<OrderModal
				isOpen={orderOpen}
				onClose={() => setOrderOpen(false)}
				api={api}
			/>
			{popUp && api.data ? (
				<PopUp
					message="Заявка успешно отправлена!"
					status="success"
					showTime={3000}
					setStateFunction={setPopUp}
				/>
			) : null}
			{popUp && api.error ? (
				<PopUp
					message="Ошибка отправки! Попробуйте позже."
					status="error"
					showTime={3000}
					setStateFunction={setPopUp}
				/>
			) : null}
		</>
	);
};

export default ContactFab;
